import { RolesEnum } from '../enums/roles.enum'

export const RolesTranslate: Record<RolesEnum, string> = {
	[RolesEnum.superAdmin]: 'Супер-администратор',
	[RolesEnum.manager]: 'Менеджер',
	[RolesEnum.superManager]: 'Супер-менеджер',
	[RolesEnum.marketing]: 'Маркетинг',
}